<template>
  <el-carousel class="home-carousel" :class="{'pic-news-carousel': isPicNews}" :interval="5000" arrow="never">
    <el-carousel-item v-for="item in list" :key="item.id">
      <div @click="handleClick(item)" class="img-box">
        <img :src="item.url" width="100%" alt="">
      </div>
      <p class="carousel-title">{{ item.newsTitle }}</p>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  props: {
    carousel: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [],
      isPicNews: false
    }
  },
  watch: {
    carousel: {
      immediate: true,
      handler(newVal) {
        if(newVal) {
          if(newVal[0]?.newsTitle) {
            this.isPicNews = true
          }
          this.list = newVal.map(item => ({
          ...item,
          url: item?.url || item?.newsImg || ""
        }))
        }
      },
    }
  },
  methods: {
    handleClick(item) {
      if(!item.newsMenuId) return
      this.$router.push({
        path: `/index/info/${item.id}`,
        query: {
          linkMenuId: item?.newsMenuId || ""
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-carousel ::v-deep {
  .el-carousel__indicators {
    transform: none;
    right: 0;
    left: unset;
    padding-right: 20px;
    padding-top: 8px;
    height: 30px;
    width: 164px;
    .el-carousel__indicator {
      padding: 0;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      background: #ffffff;
      margin-left: 8px;
      .el-carousel__button {
        background: transparent;
        height: 16px;
        width: 16px;
      }
    }
    .is-active {
      background: #0268b3;
    }
    }
}
.pic-news-carousel ::v-deep {
  .el-carousel__item .img-box {
    cursor: pointer;
    height: 100%;
    position: relative;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
   }
  }
  position: relative;
  .carousel-title {
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    line-height: 28px;
    color: #ffffff;
    position: absolute;
    bottom: 0;
    left: 0;
    padding-left: 20px;
    padding-right: 164px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>